<div class="message-box_background"></div>
<div class="message-box_content" [class.message-box_content--centered]="centered()" [class.message-box_content--compact]="density() === 'compact'">
  <div class="message-box_icon">
    <div #ref>
      <ng-content select="[messageIcon]"></ng-content>
    </div>
    @if (ref.children.length === 0) {
      <celum-icon class="message-box_icon--internal" [configuration]="internalIcon()"></celum-icon>
    }
  </div>
  <div class="message-box_text" [class.message-box_text--space-between]="textContentAlignment() === 'space-between'">
    <span [innerHTML]="text() ? (text() | translate | sanitized) : ''"></span>
    <ng-content select="[messageText]"></ng-content>
  </div>
</div>
